// CardRoutes.js
import React from "react";
import { Route, Routes } from "react-router-dom";

import ROUTES_NAVIGATION from "./routes";
import TermsetList from "../components/DealerManagement/Admin/TermSet/TermList";
import AddNewTerm from "../components/DealerManagement/Admin/TermSet/AddTerm";
import EditTerm from "../components/DealerManagement/Admin/TermSet/EditTerm";




const TermRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES_NAVIGATION.TERMLIST}
        element={<TermsetList />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDTERM}
        element={<AddNewTerm />}
      />

      <Route 
      path={ROUTES_NAVIGATION.EDITTERM}
      element={ <EditTerm/> }
      />
   
   
     
    

      
    </>
  );
};

export default TermRoutes;
